<template>
    <div class="w100" style="position: relative">
        <Header2></Header2>
        <div class="about-top w100 textCenter fontWhite">
            <h1>唐宋大数据，聚焦经营 服务交易</h1>
            <h3>———————————————— About Us ————————————————</h3>
        </div>
        <div class="">
            <div class="mw-modular-box about-part-1 wContent center" style="margin-top: 40px;">
                <div class="fontWhite h1">
                    <span class="inlineBlock vMid textRight">
                        <span class="eng" style="font-size: 14px;">COMPANY PROFILE</span><br>
                        <small class="font14">公司概况</small>
                        <span class="red-border"></span>
                    </span>
                    <!-- <span class="inlineBlock vMid textCenter h1-2">关于唐宋</span> -->
                    <span class="inlineBlock vMid font18 h1-3">中国工业大数据十大创新引领企业</span>
                </div>
                <div class="main">
                    <div class="main-right p20 font16 fontWhite">
                        <p>唐宋大数据产业股份有限公司（简称唐宋数据）是中国知名的产业大数据运营服务机构，致力于打造大数据 + 互联网生态平台。公司采用国际领先的大数据技术，依托独创的BDCPP（<br>BigData大数据 + Cloud行业云 + Portal垂直门户 + Portable移动电商）凭条架构，对产业价值链进行深度剖析，通过资产(商品)比价、企业征信和行情舆论三大系统，构建立足产业的大数据体系。</p>
                        <p>该体系从底层打通数据流、交易流和金融流，最大化消弭市场中普遍存在的信息不对称现象，极大提升资产错配和市场交易的效率，通过大数据优化商品交易和金融信用交易，实现数据、交易和金融的"三业融合"。</p>
                    </div>
                </div>
            </div>

            <div class="about-part-2-box">
                <div class="about-part-2 wContent center">
                    <div>
                        <p class="fontBold title">商业定位</p>
                        <p class="font20">深耕钢铁产业的第三方平台</p>
                        <p class="font20">大数据为主驱动的企业</p>
                        <p class="font20">大数据、交易与金融”三业融合”的商业体</p>
                    </div>
                </div>

                <div class="about-part-3 wContent center">
                    <div class="title-box textCenter">
                        <span class="font14 fontLight">研发ABCDE五大算法系统独领行业风骚，与企业深度融合创立大数据项目合作模式</span>
                        <span class="service textRight">
                            <span class="eng">SERVICES</span><br>
                            <small class="font14">五大服务</small>
                        </span>
                    </div>
                    <el-row>
                        <el-col :span="8">
                            <div class="list-box textCenter">
                                <h4 class="font16 fontBold"><span>大数据项目服务</span><span class="font16 block">BigData Oriented Project</span></h4>
                                <p class="font12 fontLight">与行业龙头企业合作共建大数据经营决策系统<br>依托唐宋大数据完善的数据、算法和技术能力，融合客户自身的数据和业务，为企业量身定制智慧经营决策系统</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="list-box textCenter">
                                <h4 class="font16 fontBold"><span>信息数据服务</span><span class="font16 block">Information&Data Services</span></h4>
                                <p class="font12 fontLight">十万移动端信息用户累占行业前茅<br>用户粘结率持续行业领先<br>大范围返利用户赢得行业赞许客户尊重<br>唤醒你的不是闹钟，而是唐宋短信息</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="list-box textCenter">
                                <h4 class="font16 fontBold"><span>供应链服务</span><span class="font16 block">Supply Chain Services</span></h4>
                                <p class="font12 fontLight">立足唐宋大数据平台资源和专业优势，与客户深度合作，打通产业链，融通价值链，围绕供应链领域深化各种服务</p>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <div class="list-box textCenter">
                                <h4 class="font16 fontBold"><span>期现货咨询服务</span><span class="font16 block">Futures Related Services</span></h4>
                                <p class="font12 fontLight">在库存管理、期现双套、基差交易以及单边投资方面提供咨询服务</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="list-box textCenter">
                                <h4 class="font16 fontBold"><span>多元集成服务</span><span class="font16 block">Value Added Services</span></h4>
                                <p class="font12 fontLight">依托唐宋平台，与各界超一流机构合作，在各专业领域深耕，围绕钢铁企业整体能力提升，持续提供多维服务</p>
                            </div>
                        </el-col>
                        <el-col :span="8">&nbsp;</el-col>
                    </el-row>
                </div>
            </div>

            <div class="mw-modular-box about-part-4-box">
                <div class="about-part-4"></div>
                <div class="about-part-5 wContent center">
                    <div class="title-box textCenter">
                        <span class="font14 fontLight">一直在创新 始终在引领  唐宋信息：值得信赖的“老字号”</span>
                        <span class="service textRight">
                            <span class="eng">HISTORY</span><br>
                            <small class="font14">发展历程</small>
                        </span>
                    </div>
                </div>

                <div class="about-part-6 mw-modular-box">
                    <div class="top">
                        <div class="wContent center">
                            <div class="timeline-main" style="left: 220px; top: 10px">唐铁行业手机端行情报价；中国钢铁产业网；中国钢铁进出口网；中国钢铁产业网；中国钢铁人才网；《钢铁情报》；创刊《钢铁经济》。</div>
                            <div class="timeline-main" style="left: 710px; top: 10px">钢铁竞争情报；智能化投资模型Pricego;一带一路经济地图；钢铁大数据价值链分类；钢铁价格定价/比价中心；唐宋100指数；监测预警改版上线。</div>
                            <div class="wContent timelines">
                                <span class="timeline-box inlineBlock textCenter">
                                    <span class="inlineBlock vBot font16 fontRed fontBold">2005年公司成立</span><br>
                                    <span class="circle-box inlineBlock vBot"><i class="inlineBlock"></i></span>
                                </span>
                                <span class="timeline-box inlineBlock textCenter">
                                    <span class="inlineBlock vBot font14">2005-2008年信息唐宋</span><br>
                                    <span class="circle-box inlineBlock vBot"><i class="inlineBlock"></i></span>
                                </span>
                                <span class="timeline-box inlineBlock textCenter">
                                    <span class="inlineBlock vBot font14">2009-2014年数据唐宋</span><br>
                                    <span class="circle-box inlineBlock vBot"><i class="inlineBlock"></i></span>
                                </span>
                                <span class="timeline-box inlineBlock textCenter">
                                    <span class="inlineBlock vBot font14">2015-2017年大数据唐宋</span><br>
                                    <span class="circle-box inlineBlock vBot"><i class="inlineBlock"></i></span>
                                </span>
                                <span class="timeline-box inlineBlock textCenter">
                                    <span class="inlineBlock vBot font14">2018-至今 生态唐宋</span><br>
                                    <span class="circle-box inlineBlock vBot"><i class="inlineBlock"></i></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="wContent center">
                            <div class="timeline-main" style="left: 480px; top: 60px">唐宋钢铁经济地图；钢铁行业首家专业数据库；唐宋钢铁APP；唐宋钢铁基准价体系；钢铁调查信息系统；唐宋在线监测预警平台；唐宋钢铁经济研究院；</div>
                            <div class="timeline-main" style="left: 960px; top: 60px">全面推进“三业融合”平台发展模式；推出唐宋大数据战略生态共赢系统</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="">
                <div class="about-part-7 wContent center">
                    <div>
                        <p class="fontBold title">商业使命</p>
                        <p class="font20">唐宋大数据立足于通过大数据技术的创新引领，<br>服务并提升传统产业智慧决策；<br>并通过与客户的深度共融，<br>实现唐宋“三业融合”商业模式的可持续发展。</p>
                    </div>
                </div>
                <div class="about-part-8 wContent center">
                    <div class="title-box textCenter">
                        <span class="font14 fontLight">一万家样本企业，精心编织行业快速准确信息网络日超十万条信息数据汇集整理</span>
                        <span class="service textRight">
                            <span class="eng">BASICS</span><br>
                            <small class="font14">基础支撑</small>
                        </span>
                    </div>
                </div>
            </div>

            <div class="about-part-9 mw-modular-box wContent center fontWhite textCenter">
                <div class="msg-box-1 inlineBlock vTop">
                    <div class="msg-text-box">
                        <p class="show font16">信息系数据全面准确</p>
                        <p class="p10 textLeft">
                            唐宋100指数做到钢铁产业链信息采集全覆盖<br>
                            信息采集实现人工与技术采集相结合<br>
                            API接口实时推送数据<br>
                            基础算法体系日臻成熟<br>
                            ABCDE五大算法系统引领行业<br>
                            AI技术加快研发落地
                        </p>
                    </div>
                </div>
                <div class="msg-box-2 inlineBlock vTop">
                    <div class="msg-text-box">
                        <p class="show font16">算法体系日臻完善</p>
                        <p class="p10 textLeft">
                            唐宋100指数做到钢铁产业链信息采集全覆盖<br>
                            信息采集实现人工与技术采集相结合<br>
                            API接口实时推送数据<br>
                            基础算法体系日臻成熟<br>
                            ABCDE五大算法系统引领行业<br>
                            AI技术加快研发落地
                        </p>
                    </div>
                </div>
                <div class="msg-box-3 inlineBlock vTop">
                    <div class="msg-text-box">
                        <p class="show font16">7x24x365全流域服务</p>
                        <p class="p10 textLeft">
                            唐宋100指数做到钢铁产业链信息采集全覆盖<br>
                            信息采集实现人工与技术采集相结合<br>
                            API接口实时推送数据<br>
                            基础算法体系日臻成熟<br>
                            ABCDE五大算法系统引领行业<br>
                            AI技术加快研发落地
                        </p>
                    </div>
                </div>
                <div class="msg-box-4 inlineBlock vTop">
                    <div class="msg-text-box">
                        <p class="show font16">大数据技术先进独特</p>
                        <p class="p10 textLeft">
                            唐宋100指数做到钢铁产业链信息采集全覆盖<br>
                            信息采集实现人工与技术采集相结合<br>
                            API接口实时推送数据<br>
                            基础算法体系日臻成熟<br>
                            ABCDE五大算法系统引领行业<br>
                            AI技术加快研发落地
                        </p>
                    </div>
                </div>
            </div>

            <div class="mw-modular-box wContent center bgWhite billet-part-5 about-part-4-box" style="border: 1px solid #ccc; margin-top: 60px;">
                <div class="about-part-5 wContent center">
                    <div class="title-box textCenter">
                        <span class="font14 fontLight">服务是为客户提供价值的一种手段，使客户不用承担额外的成本和风险就可获得所期望的结果</span>
                        <span class="service textRight">
                            <span class="eng">CONTACT</span><br>
                            <small class="font14">联系方式</small>
                        </span>
                    </div>
                </div>
                <div class="get-concat-box center" style="width: 870px;">
                    <div class="inlineBlock vTop" style="margin-top: -15px;">
                        服务热线：400-6565-958 <br>
                        <!-- 总公司：Bejing Head Office <br>
                        地址：北京市海淀区西三环北路89号中国外文大厦A906 <br>
                        电话：010-88570912/88570922传真：010-88570922 <br> -->
                        总部基地：Headquarters Base <br>
                        地址：河北省唐山市高新区建设北路冀东新闻中心5层 <br>
                        电话：0315-5921001/400-6565-958传真：0315-5921091/5921092 <br>
                    </div>
                    <div style="height: auto; width: 155px; margin-left: 100px; margin-top: 0" class="inlineBlock vTop textCenter">
                        <img src="../../assets/images/header_code.png" alt="" srcset="">
                        <p class="textCenter font14">扫一扫关注公众号</p>
                    </div>
                    <div style="height: auto; margin-top: 0; margin-left: 50px" class="inlineBlock vTop textCenter">
                        <img src="../../assets/images/footer_down.png" alt="" srcset="" style="width: 117px; margin-top: 6px; margin-bottom: 4px;">
                        <p class="textCenter font14">唐宋钢铁APP</p>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header2 from '../../templates/header_2'
import Footer from '../../templates/footer'
export default {
    name: 'AboutUs',
    components: { Header2, Footer },
    data () {
        return {
        }
    },
    mounted () {
        // 初始化内容
    },
    methods: {}
}
</script>

<style scoped>
    .about-top { height: 500px; box-sizing: border-box; box-shadow: 0px -5px 10px rgba(0,0,0,0.2); background: url('../../assets/images/aboutus_1.png') no-repeat; background-size: 100% 100%; padding-top: 240px; }
    .about-top h1 { font-size: 50px; }
    .about-top h3 { font-size: 24px; font-weight: 400; margin-top: 20px; }
    .about-part-1 .h1 { background: #333; box-sizing: border-box; height: 80px; }
    .about-part-1 .h1 > span:first-child { width: 300px; margin-right: 200px; margin-top: 15px; position: relative; }
    .about-part-1 .h1 > span:first-child > .red-border { position: absolute; top: -57px; left: 155px; width: 180px; height: 122px; background: url('../../assets/images/aboutus_right.png') no-repeat; background-size: 100% 100%; }
    .about-part-1 .h1 .eng { font-size: 24px; font-weight: 100; }
    .about-part-1 .h1 small { font-weight: 100; }
    .about-part-1 .h1 .h1-2 { font-size: 34px; margin-top: 15px; margin-right: 60px; letter-spacing: 0.2rem; }
    .about-part-1 .h1 .h1-3 { margin-top: 20px; margin-left: -30px; }
    .about-part-1 .main { height: 500px; background: url('../../assets/images/aboutus_2.png') no-repeat; background-size: 100% 100%; margin-bottom: 40px; }
    .about-part-1 .main .main-right { box-sizing: border-box; width: 45%; float: right; height: 500px; background: rgba(0,0,0,0.7); padding: 30px 40px; }
    .about-part-1 .main .main-right p { text-indent: 2rem; font-weight: 100; line-height: 30px; margin-top: 30px;}
    .about-part-2-box { border: 2px solid #eee; }
    .about-part-2, .about-part-7 { height: 265px; background: url('../../assets/images/aboutus_3.png') no-repeat; background-size: 100% 100%; margin-top: 40px; color: #e0382d; }
    .about-part-2 > div, .about-part-7 > div { margin-left: 100px; padding-top: 60px; box-sizing: border-box; }
    .about-part-2 p, .about-part-7 p { line-height: 35px; text-shadow: 1px 1px 0px #fff, -1px -1px 0px #fff; }
    .about-part-2 .title, .about-part-7 .title { font-size: 30px; margin-bottom: 20px; }
    .about-part-3, .about-part-5, .about-part-8 { padding: 50px; box-sizing: border-box; }
    .about-part-3 .title-box, .about-part-5 .title-box, .about-part-8 .title-box { border-bottom: 2px solid #eee; position: relative; padding-bottom: 50px; box-sizing: border-box; }
    .about-part-3 .service, .about-part-5 .service, .about-part-8 .service { position: absolute; right: 20px; top: -90px; background: url('../../assets/images/aboutus_left.png') no-repeat; background-size: 100% 100%; width: 180px; height: 140px; padding: 60px 15px 0 0; box-sizing: border-box;}
    .about-part-3 .service .eng, .about-part-5 .service .eng, .about-part-8 .service .eng { font-size: 30px; font-weight: 400; }
    .about-part-3 .list-box { height: 180px; padding: 0 60px; box-sizing: border-box; }
    .about-part-3 .list-box h4 { height: 60px; font-weight: 400; line-height: 25px; margin-top: 30px; }
    .about-part-3 .list-box p { line-height: 28px; }
    .about-part-4 { height: 310px; background: url('../../assets/images/aboutus_4.png') no-repeat; background-size: 100% 100%; }
    .about-part-5 .service { right: auto; left: 20px; background: url('../../assets/images/aboutus_right.png') no-repeat;  background-size: 100% 100%; padding: 60px 30px 0 0px; box-sizing: border-box;}
    .about-part-6 .top, .about-part-6 .bottom, .about-part-6 .top > div, .about-part-6 .bottom > div { height: 200px; }
    .about-part-6 .top > div, .about-part-6 .bottom > div { position: relative; }
    .about-part-6 .top { border-bottom: 1px solid #333; }
    .about-part-6 .bottom { border-top: 1px solid #333; }
    .about-part-6 .timelines { position: absolute; bottom: -36px; }
    .about-part-6 .timelines .timeline-box { width: 20%; height: 80px; }
    .circle-box { border: 1px solid #333; border-radius: 50%; line-height: 38px; height: 30px; width: 30px; margin-top: 10px;}
    .circle-box i { border: 1px solid #333; border-radius: 50%; background: #333; width: 16px; height: 16px; }
    .timeline-main { width: 250px; line-height: 24px; border: 1px solid #ccc; border-radius: 5px; padding: 5px; position: absolute; }
    .about-part-9 { padding: 20px 0; box-sizing: border-box; }
    .about-part-9 > div { width: 250px; margin-right: 60px; height: 350px; position: relative; overflow: hidden; }
    .about-part-9 > div:last-child { margin-right: 0; }
    .about-part-9 .msg-box-1 { background: url('../../assets/images/aboutus_f_1.png') no-repeat; background-size: 100% 100%; }
    .about-part-9 .msg-box-2 { background: url('../../assets/images/aboutus_f_2.png') no-repeat; background-size: 100% 100%; }
    .about-part-9 .msg-box-3 { background: url('../../assets/images/aboutus_f_3.png') no-repeat; background-size: 100% 100%; }
    .about-part-9 .msg-box-4 { background: url('../../assets/images/aboutus_f_4.png') no-repeat; background-size: 100% 100%; }
    .about-part-9 .msg-text-box { position: absolute; bottom: -190px; left: 0; background: rgba(0,0,0,0.5); width: 100%; height: 240px; }
    .about-part-9 p { line-height: 24px; }
    .about-part-9 .show { line-height: 50px; }

    /* Chrome, Safari, Opera */
    /* .about-part-9 > div:hover .msg-text-box { animation: mymove  0.5s 1; animation-fill-mode: forwards; }
    @-webkit-keyframes mymove {
        100% { bottom: 0;  }
    }
    @keyframes mymove {
        100% { bottom: 0;  }
    } */
    /* Standard syntax */
</style>